export default __webpack_public_path__ + "static/media/picture_scroll1.250440c3.jpg";